export const detectPolicyIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete policy" || cleaned === "remove policy") {
        return { intent: "delete_policy" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) policy/);
    if (deleteMatch) {
        return { intent: "delete_policy", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create policy") || cleaned.includes("add policy")) {
        return { intent: "create_policy" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create policy named (.+)/);
    if (createMatch) {
        return { intent: "create_policy", name: createMatch[1].trim() };
    }

    return null;
};
